"use strict";

define('service/user',['require','exports','module','appkit/service','backbone','../config','uikit/uikit','../view/role.dropdown.view','rs/models/session'],function (require, exports, module) {
  var Service = require('appkit/service'),
    Backbone = require('backbone'),
    config = require('../config'),
    UIKit = require('uikit/uikit'),
    RoleDropdown = require('../view/role.dropdown.view'),
    Session = require('rs/models/session');
  var UserService = Service.extend({
    inject: ['legacyApp'],
    replies: {
      'roleChoices': 'getAvailableRoleChoices',
      'roleDropdown': 'roleDropdown',
      'userDropdown': 'buildUserDropdown',
      'logout': 'logout'
    },
    events: {
      'user:settings': 'setupAppRoles',
      'authenticated': 'onAuthenticated',
      'notification:muteToggle': 'onNotificationMuteToggle'
    },
    initialize: function initialize() {
      this.app.role = new Backbone.Model();
      this.app.muteOption = new Backbone.Model();
      this.availableRoleChoices = new Backbone.Collection();
      this.userActions = new Backbone.Collection();
    },
    onAuthenticated: function onAuthenticated(user) {
      this.currentUser = user;
      this.onCurrentUserInfo(user);
    },
    onCurrentUserInfo: function onCurrentUserInfo(user) {
      this.setupUserActions(user);
    },
    setupUserActions: function setupUserActions(user) {
      var oneLogin = Session.isOneLogin();
      var userActions = this.userActions;
      userActions.add({
        text: user.getUsername()
      });
      userActions.add({
        text: user.associatedTenant.name
      });
      var userLinkActions = [new UIKit.Dropdown.DividerModel()];
      if (oneLogin) {
        userLinkActions.push({
          text: 'Profile',
          icon: 'user',
          link: 'https://' + user.associatedTenant.hostname + '/profile'
        });
      }
      userLinkActions.push({
        text: 'Help Center',
        icon: 'question',
        link: 'https://support.cayuse.com'
      });
      userLinkActions.push({
        text: this.app.phrase('App.LogOut'),
        icon: 'power',
        action: 'logout'
      });
      userActions.add(userLinkActions);
    },
    buildUserDropdown: function buildUserDropdown() {
      var userDropdown = new UIKit.Dropdown({
        attributes: _.extend(UIKit.Dropdown.prototype.attributes, {
          role: 'menuitem'
        }),
        className: UIKit.Dropdown.prototype.className + ' user-dropdown',
        iconRight: false,
        icon: 'user',
        mode: 'select',
        collection: this.userActions,
        childBindings: {
          text: 'text',
          icon: 'icon',
          collection: 'children',
          value: 'value',
          description: 'description',
          link: 'link'
        }
      });
      userDropdown.updateElementAttributes({
        'aria-label': 'Account',
        'aria-labelledby': userDropdown.cid + 'Text'
      });
      this.listenTo(this.channel, 'authenticated', function (user) {
        userDropdown.text = user.getDisplayName();
      }).listenTo(userDropdown, 'before:add:child', function (view) {
        view.menuDirection = 'left';
      }).listenTo(userDropdown, 'change:value', function (view, model) {
        if (model && model.has('action')) {
          this.channel.request(model.get('action'));
        }
      }).listenTo(userDropdown, 'dropdown:hide', function () {
        $('.common-header .user-dropdown').blur();
      });
      return userDropdown;
    },
    buildRoleDropdown: function buildRoleDropdown() {
      var roleDropdown = new RoleDropdown({
        name: 'roleDropdown',
        header: 'Role:',
        collection: this.getAvailableRoleChoices(),
        className: RoleDropdown.prototype.className + ' role-dropdown',
        childBindings: {
          text: 'displayName',
          role: 'description',
          favoriteRole: 'favoriteRole'
        }
      });
      return roleDropdown;
    },
    roleDropdown: function roleDropdown() {
      var roleDropdown = this.buildRoleDropdown(),
        self = this;
      function setupInitialValue() {
        var availableRoleChoices = self.getAvailableRoleChoices();
        if (self.hasFavoriteRoleSetting()) {
          if (!roleDropdown.value) {
            roleDropdown.value = self.getSelectedRole();
          }
          if (availableRoleChoices.length < 2) {
            roleDropdown.icon = '';
            roleDropdown.activation = '';
            roleDropdown.visible = false;
          }
        }
      }
      ;
      roleDropdown.on('press', function (choice) {
        roleDropdown.value = choice;
      });
      roleDropdown.on('change:value', function (view, value, oldValue) {
        self.setSelectedRole(value);
        app.role.set(self.getSelectedRole().attributes);
        if (oldValue) {
          app.execute('achievement:unlock', 'Multiple Hats');
        }
      });
      roleDropdown.on('childview:change:favoriteRole', function (childView, junk, value) {
        var notFavorite = value !== true;
        if (notFavorite || !this.children) {
          return;
        }
        var children = this.children;
        _.map(children._views, function (child) {
          if (!child) {
            return;
          }
          var notSelectedFavoriteRole = child.text !== childView.text;
          if (notSelectedFavoriteRole) {
            child.favoriteRole = false;
          }
        });
      });
      roleDropdown.listenToOnce(this.channel, 'user:settings', setupInitialValue);
      setupInitialValue();
      return roleDropdown;
    },
    onNotificationMuteToggle: function onNotificationMuteToggle(userSettings) {
      this.muteOptionSetting = userSettings.findWhere({
        name: config.settings.MUTE_OPTION
      });
      var muteOptionValue = this.muteOptionSetting.get('value');
      this.muteOptionSetting.set('value', !muteOptionValue);
      this.app.muteOption = this.muteOptionSetting.get('value');
    },
    getAvailableRoleChoices: function getAvailableRoleChoices() {
      return this.availableRoleChoices;
    },
    getSelectedRole: function getSelectedRole() {
      return this.selectedRoleChoice;
    },
    setSelectedRole: function setSelectedRole(role) {
      this.selectedRoleChoice = role;
      return this;
    },
    hasFavoriteRoleSetting: function hasFavoriteRoleSetting() {
      return !!this.favoriteRoleSetting;
    },
    setupAppRoles: function setupAppRoles(userSettings) {
      var app = this.app;
      this.favoriteRoleSetting = userSettings.findWhere({
        name: config.settings.FAVORITE_ROLE
      });
      this.muteOptionSetting = userSettings.findWhere({
        name: config.settings.MUTE_OPTION
      });
      this.app.muteOption = this.muteOptionSetting.get('value');
      this.channel.reply('setRoleFavorite', function (choice) {
        this.favoriteRoleSetting.set('value', choice.get('description'));
      }, this);
      var choices = this.favoriteRoleSetting.get('choices');
      this.availableRoleChoices.set(choices.filter(function (choice) {
        return !!app.authorities.findWhere({
          authority: choice.get('description')
        });
      }));
      this.selectedFavoriteRoleChoice = this.availableRoleChoices.find(function (choice) {
        return choice.get('description') == this.favoriteRoleSetting.get('value');
      }, this);
      this.channel.trigger('roleFavoriteChoice', this.selectedFavoriteRoleChoice);
      this.selectedRoleChoice = this.selectedFavoriteRoleChoice || this.availableRoleChoices.at(0);
      this.favoriteRoleSetting.on('change:value', function () {
        this.favoriteRoleSetting.save();
      }, this);
      this.muteOptionSetting.on('change:value', function () {
        this.muteOptionSetting.save();
      }, this);
    },
    logout: function logout() {
      this.legacyApp.requestLogout();
    }
  });
  module.exports = UserService;
});

